module.exports = __webpack_public_path__ + "static/media/ecommerce.2c8e2f4b.png";